module.exports = __webpack_public_path__ + "static/img/医嘱开立前置合规检查.3a8d60c7.png";